






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate/dist/types/components/Observer';
import { UserModule } from '@/store/modules/user/user.store';
import { BugTrackerIssueViewObject } from '@/types/apiServerContract';
import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';

@Component
export default class BugTrackerDetailsSubmitComment extends Vue {
	@Prop({ required: true }) issue!: BugTrackerIssueViewObject;

	loading: boolean = false;
	comment: string = '';

	timeUntilNextNewsComment() {
	    const now = new Date();
	    return UserModule.lastNewsComment ? Math.round((UserModule.lastNewsComment.getTime() - now.getTime()) / 1000) : 0;
	}

	get user() {
	    return UserModule.user;
	}

	get isAdmin() {
	    return this.user?.IsAdmin;
	}

	async submit() {
	    if (!this.isAdmin && this.timeUntilNextNewsComment() > 0) {
	        this.$bvToast.toast(`You must wait ${this.timeUntilNextNewsComment()} seconds, before submitting a new comment.`, {
	            variant: 'danger',
	            title: 'Failed',
	            solid: true
	        });

	        return;
	    }

	    this.loading = true;

	    try {
	        await BugTrackerModule.addComment({ issueId: this.issue.id, comment: this.comment });

	        this.reset();
	        this.$emit('submit');
	        UserModule.SetNewsCommentTimer(30);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Comment submitted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	reset() {
	    this.comment = '';
	    this.$refs.validator.reset();
	}

	public $refs!: {
		validator: InstanceType<typeof ValidationObserver>;
	};
}
